export type Optional<T, K extends keyof T> = Pick<Partial<T>, K> & Omit<T, K>;
/**
 * Function for TS to check passed key is in obj
 * @param key
 * @param obj
 */
export const isObjKey = <T extends object>(key: PropertyKey, obj: T): key is keyof T => key in obj;
export type NullablePartial<T> = { [P in keyof T]?: T[P] | null };

// Convert upper snake case to camel case
export type UpperSnakeToCamelCase<S extends string> = S extends `${infer T}_${infer U}`
    ? `${Lowercase<T>}${Capitalize<UpperSnakeToCamelCase<U>>}`
    : Lowercase<S>;

// Filter and rename attributes
export type ConvertToCamelCaseAndOmit<T, K extends keyof T> = {
    [P in Exclude<keyof T, K> as UpperSnakeToCamelCase<string & P>]: T[P];
};

// Converts camel case string to upper snake case
export type CamelToUpperSnakeCase<S extends string> = S extends `${infer T}${infer U}`
    ? T extends Lowercase<T>
        ? `${Uppercase<T>}_${CamelToUpperSnakeCase<U>}`
        : `${T}${CamelToUpperSnakeCase<U>}`
    : S;

export type ConvertToUpperSnakeCase<T> = {
    [P in keyof T as CamelToUpperSnakeCase<string & P>]: T[P];
};
